import OrderDetailPage from "./orderDetailPage";
export default OrderDetailPage;
